import {
  createPinRequestSchema,
  newEmailVerificationGeneratedSchema,
  newPhoneVerificationGeneratedSchema,
  notFoundResponseSchema,
  pinCreatedResponseSchema,
  pinIdentityNotFoundResponseSchema,
  pinUserNotExternalResponseSchema,
  unauthorizedResponseSchema,
  unprocessableEntityResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const endpoints = {
  'onboarding.email.verification.regenerate': {
    method: 'POST',
    url: `${API_URL_BASE}auth/resend-email-verification`,
    requestSchema: z.undefined(),
    responseSuccessSchema: newEmailVerificationGeneratedSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      401: unauthorizedResponseSchema,
      404: notFoundResponseSchema,
      422: notFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof newEmailVerificationGeneratedSchema,
    {
      401: typeof unauthorizedResponseSchema;
      404: typeof notFoundResponseSchema;
      422: typeof notFoundResponseSchema;
    }
  >,
  'onboarding.phone.verification.regenerate': {
    method: 'POST',
    url: `${API_URL_BASE}auth/resend-phone-verification`,
    requestSchema: z.undefined(),
    responseSuccessSchema: newPhoneVerificationGeneratedSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      401: unauthorizedResponseSchema,
      404: notFoundResponseSchema,
      422: notFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof newPhoneVerificationGeneratedSchema,
    {
      401: typeof unauthorizedResponseSchema;
      404: typeof notFoundResponseSchema;
      422: typeof notFoundResponseSchema;
    }
  >,
  'onboarding.pin.set': {
    method: 'POST',
    url: `${API_URL_BASE}auth/pin`,
    requestSchema: createPinRequestSchema,
    responseSuccessSchema: pinCreatedResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      403: pinUserNotExternalResponseSchema,
      400: unprocessableEntityResponseSchema,
      404: pinIdentityNotFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof createPinRequestSchema,
    typeof pinCreatedResponseSchema,
    {
      403: typeof pinUserNotExternalResponseSchema;
      400: typeof unprocessableEntityResponseSchema;
      404: typeof pinIdentityNotFoundResponseSchema;
    }
  >,
} as const;

export default endpoints;
